import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateMercadoCategoriesInput,
    DeleteMercadoCategoriesInput,
    MercadoCategories,
    ModelMercadoCategoriesFilterInput,
    UpdateMercadoCategoriesInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class MercadoCategoriesService {
    private amplifyClient = generateClient();
    constructor() {}

    async listMercadoCategories(): Promise<MercadoCategories[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listMercadoCategories
                })
            ).data.listMercadoCategories.items;
            if (data) return data as MercadoCategories[];
        } catch (error) {
            console.error('Error finding MercadoCategories:', error);
            return null;
        }
    }

    async listAllMercadoCategories(
        filter: ModelMercadoCategoriesFilterInput = null,
        pageLimit: number = 100
    ): Promise<MercadoCategories[]> {
        const categories: MercadoCategories[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.listMercadoCategories,
                        variables: {
                            filter,
                            limit: pageLimit,
                            nextToken
                        }
                    })
                ).data.listMercadoCategories;
                categories.push(
                    ...((response?.items ?? []) as MercadoCategories[])
                );
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);
            return categories;
        } catch (error) {
            console.error('Error finding MercadoCategories:', error);
            return [];
        }
    }

    async createMercadoCategories(
        input: CreateMercadoCategoriesInput
    ): Promise<MercadoCategories> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createMercadoCategories,
                    variables: {
                        input
                    }
                })
            ).data.createMercadoCategories;
            if (date) return date as MercadoCategories;
        } catch (error) {
            console.error('Error creating MercadoCategories:', error);
            return null;
        }
    }
    async UpdateMercadoCategories(
        input: UpdateMercadoCategoriesInput
    ): Promise<MercadoCategories> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateMercadoCategories,
                    variables: {
                        input
                    }
                })
            ).data.updateMercadoCategories;
            if (date) return date as MercadoCategories;
        } catch (error) {
            console.error('Error creating MercadoCategories:', error);
            return null;
        }
    }

    async deleteMercadoCategories(
        input: DeleteMercadoCategoriesInput
    ): Promise<MercadoCategories> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteMercadoCategories,
                    variables: {
                        input
                    }
                })
            ).data.deleteMercadoCategories;
            if (data) return data as MercadoCategories;
        } catch (error) {
            console.error('Error deleting MercadoCategories:', error);
            return null;
        }
    }
}
